import { Link } from "wouter";
import { useToast } from "@/hooks/use-toast";

export default function Footer() {
  const { toast } = useToast();

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handlePhoneCopy = async () => {
    const phoneNumber = "+1 (912) 506-3967";
    try {
      await navigator.clipboard.writeText(phoneNumber);
      toast({
        title: "Phone Number Copied!",
        description: phoneNumber,
      });
    } catch (error) {
      toast({
        title: "Failed to copy",
        description: "Please try again",
        variant: "destructive",
      });
    }
  };
  return (
    <footer className="bg-black text-white pt-10 pb-6">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div>
            <img
              src="/assets/images/logo02.png"
              alt="DanceRealmX Logo"
              className="h-12 mb-4"
            />
            <p className="text-gray-400">
              Empowering dance educators with resources, training, and community.
            </p>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">Platform</h3>
            <ul className="space-y-2">
              <li>
                <Link href="/courses" className="text-gray-400 hover:text-brand" onClick={scrollToTop}>
                  Certification
                </Link>
              </li>
              <li>
                <Link href="/curriculum" className="text-gray-400 hover:text-brand" onClick={scrollToTop}>
                  Curriculum
                </Link>
              </li>
              <li>
                <Link href="/connect" className="text-gray-400 hover:text-brand" onClick={scrollToTop}>
                  Connect & Book
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">About</h3>
            <ul className="space-y-2">
              <li>
                <Link href="/about" className="text-gray-400 hover:text-brand" onClick={scrollToTop}>
                  About Us
                </Link>
              </li>
              <li>
                <Link href="/subscription" className="text-gray-400 hover:text-brand" onClick={scrollToTop}>
                  Plans & Pricing
                </Link>
              </li>
              <li>
                <Link href="/support" className="text-gray-400 hover:text-brand" onClick={scrollToTop}>
                  Help & Support
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">Contact</h3>
            <p className="text-gray-400">512 Jake Strouse Road</p>
            <p className="text-gray-400">Statesboro, GA 30461</p>
            <p className="text-gray-400 mb-4">USA</p>
            <div className="flex space-x-4">
              <button onClick={handlePhoneCopy} className="text-gray-400 hover:text-brand transition-colors" title="Click to copy: +1 (912) 506-3967">
                <span className="sr-only">Phone</span>
                <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                  <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z" />
                </svg>
              </button>
              <a href="mailto:support@dancerealmx.com" className="text-gray-400 hover:text-brand" title="Email: support@dancerealmx.com">
                <span className="sr-only">Email</span>
                <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                  <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z" />
                </svg>
              </a>
              <a href="https://www.instagram.com/dancerealmx/?hl=en" className="text-gray-400 hover:text-brand" title="Instagram: @dancerealmx">
                <span className="sr-only">Instagram</span>
                <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                  <path fillRule="evenodd" d="M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z" clipRule="evenodd" />
                </svg>
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-10 pt-6">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 text-sm mb-4 md:mb-0">
              &copy; {new Date().getFullYear()} DanceRealmX. All rights reserved.
              <span className="ml-3 text-gray-600">v{__APP_VERSION__}</span>
            </p>
            {/* Wrap on narrow viewports so the legal-link row doesn't force
                horizontal scroll on phones. */}
            <div className="flex flex-wrap justify-center gap-x-6 gap-y-2">
              <Link href="/privacy-policy" className="text-gray-400 text-sm hover:text-brand" onClick={scrollToTop}>
                Privacy Policy
              </Link>
              <Link href="/terms-of-service" className="text-gray-400 text-sm hover:text-brand" onClick={scrollToTop}>
                Terms of Service
              </Link>
              <Link href="/guidelines" className="text-gray-400 text-sm hover:text-brand" onClick={scrollToTop}>
                User Guidelines
              </Link>
              <Link href="/copyright-policy" className="text-gray-400 text-sm hover:text-brand" onClick={scrollToTop}>
                Copyright Policy
              </Link>
              <Link href="/membership-comparison" className="text-gray-400 text-sm hover:text-brand" onClick={scrollToTop}>
                Creator Plans
              </Link>
              <Link href="/refund-policy" className="text-gray-400 text-sm hover:text-brand" onClick={scrollToTop}>
                Refund Policy
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}